import { useEffect, useState } from "react";
import { EyeOff } from "lucide-react";
import { api, fmtDate } from "../lib/api";
import { Slip } from "./Slip";
import { PicksGrid } from "./PicksGrid";

export const Submissions = ({ tid, round, client = api, base = "/tournaments" }) => {
  const [data, setData] = useState(null);
  const [slips, setSlips] = useState(null);
  useEffect(() => {
    setData(null);
    setSlips(null);
    client.get(`${base}/${tid}/submissions`, { params: { round } }).then((r) => setData(r.data)).catch(() => setData({ players: [] }));
    client.get(`${base}/${tid}/slips`, { params: { round } }).then((r) => setSlips(r.data)).catch(() => {});
  }, [tid, round, client, base]);

  if (!data) return <div className="card-surface h-40 animate-pulse" />;
  return (
    <div className="space-y-4">
      <div className="card-surface p-4" data-testid="submissions">
        <div className="flex items-baseline justify-between gap-3 mb-3">
          <h3 className="font-display text-lg font-bold uppercase">Pronostici consegnati</h3>
          <p className="text-xs text-slate-400">{data.round_label} · {data.total} partite</p>
        </div>
        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
          {data.players.map((p) => (
            <li key={p.user_id} className="flex items-center justify-between gap-2 px-3 py-1.5 rounded-md bg-[#121824] border border-[#26334D] text-sm" data-testid={`submission-${p.user_id}`}>
              <span className="font-semibold truncate">{p.name}</span>
              <span className={`text-xs font-mono ${p.submitted ? "text-emerald-400" : "text-slate-500"}`}>{p.count}/{data.total}</span>
            </li>
          ))}
        </ul>
      </div>
      {slips && !slips.visible && (
        <div className="flex items-center gap-3 rounded-xl border border-[#26334D] bg-[#121824] px-5 py-4 text-sm text-slate-400" data-testid="slips-hidden-notice">
          <EyeOff size={18} /> Le schedine saranno visibili dal {slips.lock_at ? fmtDate(slips.lock_at) : "inizio della giornata"}, alla chiusura della consegna.
        </div>
      )}
      {slips?.visible && slips.matches?.length > 0 && slips.players.length > 0 && <PicksGrid slips={slips} />}
      {slips && (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="slips-list">
          {slips.players.map((p) => (
            <Slip key={p.user_id} title={p.is_me ? `${p.name} (tu)` : p.name} slip={p} testId={`slip-${p.user_id}`} />
          ))}
        </div>
      )}
    </div>
  );
};
